 import React, { useState, useEffect } from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import PaginationOne from "../../components/pagination/PaginationOne";
import SearchOne from "../../components/widgets/blog/SearchOne";
import CategoryOne from "../../components/widgets/blog/CategoryOne";
import LatestPostOne from "../Destination/UK/LatestPostOne";
import TagOne from "../../components/widgets/blog/TagOne";
import BannerOne from "../../components/widgets/blog/BannerOne";
import PostOne from "../../components/post/PostOne";
import PostData from "../../data/blog/PostData.json";
import AboutOne from "../../components/widgets/blog/AboutOne";
import BlogDetailsOne from "./BlogDetailsOne";
import { FaSpinner } from "react-icons/fa";
import Reviews from "./Reviews";

const StudyAbroad = () => {
  const [fix,setFixed] = useState(false);
  function setFixedSideBar(){
      if((window.scrollY >= 200)){
          setFixed(true);
      }
      else{
          setFixed(false);
      }
  }
  window.addEventListener("scroll",setFixedSideBar);
  const [getAllItems] = useState(PostData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [noMorePost, setNoMorePost] = useState(false);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    setVisibleItems(getAllItems.filter((item) => item.id <= dataVisibleCount));
  }, []);

  const handleLoadMoreBtn = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;
    if (dataVisibleCount >= getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
    }
  };

  return (
    <>
      <SEO title="Study Abroad" />
      <Layout>
        <BreadcrumbOne
          title="Blog Grid With Left Sidebar"
          rootUrl="/"
          parentUrl="Home"
          currentUrl="Study Abroad"
        />

        <div className="edu-elements-area edu-section-gap bg-color-white">
          <div className="container-fluid" style={{width:"90%"}}>
            <div className="row g-1">
              {/* <div className="col-lg-7 order-2">
                <div className="row g-5">
                                    { 
                                        PostData.slice( 0, 12 ).map((item) => (
                                            <div className="col-lg-6 col-md-6 col-12" key={ item.id }>
                                                <PostOne data={item} />
                                            </div>
                                        ) )
                                    }
                                </div>
                <div className="row">
                  <div className="col-lg-12 mt--60">
                    <PaginationOne />
                  </div>
                </div>
              </div> */}
              <div className="col-lg-3">
                <div className={fix ? "myCustomSidebarCom fixed" : "myCustomSidebarCom"}>
                <aside className="edu-blog-sidebar">
                  <AboutOne />
                </aside>
                </div>
              </div>
              <div className="col-lg-7">
                <aside className="edu-blog-sidebar">
                  {/* <BlogDetailsOne/> */}
                  <Reviews
                  name="Husky shaikh"
                  image="/customizedimages/jeff.jpeg"
                  main ="Owner of Amazon"
                  para ="As Thomas pointed out, Chegg’s survey appears more
                  like a scorecard that details obstacles and
                  challenges that the current university undergraduate
                  student population is going through in their
                  universities and countries."/>
                  <Reviews
                  name="Jeff Bezos"
                  image="/customizedimages/elon.jpg"
                   main ="Owner of Starlink"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Takemichi"
                   image="/customizedimages/pexels-ono-kosuki-5648103.jpg"
                   main ="Owner of Quora"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Sakata gintoki"
                  image="/customizedimages/pexels-cottonbro-studio-4100481.jpg"
                   main ="Owner of Uber"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Himmamari"
                   image="/customizedimages/elon.jpg"
                   main ="Owner of Tesla"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Mark jeff"
                   image="/customizedimages/pexels-ono-kosuki-5648103.jpg"
                   main ="Binchin"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Husky shaikh"
                   image="/customizedimages/elon.jpg"
                   main ="Arnauld industry"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <Reviews
                  name="Husky shaikh"
                   image="/customizedimages/pexels-ono-kosuki-5648103.jpg"
                   main ="Puffman"
                   para ="As Thomas pointed out, Chegg’s survey appears more
                   like a scorecard that details obstacles and
                   challenges that the current university undergraduate
                   student population is going through in their
                   universities and countries."/>
                  <TagOne extraClass="mt--50" style2="enable" />
                </aside>
                <div className="row text-center mt--60">
                  <div className="col-lg-12">
                    <button
                      className="edu-btn"
                      onClick={handleLoadMoreBtn}
                      disabled={noMorePost ? "disabled" : null}
                    >
                      {noMorePost ? (
                        "All Posts Displayed"
                      ) : (
                        <span>
                          Load More
                          <span className="eduvibe-spin-icon">
                            <FaSpinner />
                          </span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-2">
                <aside className="edu-blog-sidebar">
                  <SearchOne style2="enable" />
                  <CategoryOne extraClass="mt--50" style2="enable" />
                  <LatestPostOne extraClass="mt--50" style2="enable" />

                  <TagOne extraClass="mt--50" style2="enable" />
                </aside>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default StudyAbroad;
